module.exports = __webpack_public_path__ + "static/scale-model-of-greetings-from-toledo-in-toledo-ohio-c9f98ead32ea4ddaf9e40d6f846b9de9.png";